import React from 'react';
import arrow_filter from '../../custom_icons/drop_arrow.svg'
import { getLocalizedStrings } from '../../utils_android/LocalizedStrings';
import flag from '../../custom_icons/flag.png'
import ChooseTypeDropdown from '../../universal_tasks/ChooseTypeDropdown';
import CountriesDropDown from './CountriesDropDown';
var strings = getLocalizedStrings()

var arrowRotate = {
    transform: 'rotate(180deg)',
    marginTop: '6px'
}
class CountryPicker extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            isShowTypes : false,
            filterPicked : strings.countryRussia,
            countries : [{text : strings.countryRussia, icon : flag}]
        } 
    }
    toogleTypes = () => {
        this.setState({isShowTypes : !this.state.isShowTypes})
    }
    onTypePicked = (type) => {
        this.setState({filterPicked : type.text})
       // this.props.typePicked(type.text)
    }
 
    render() {
        return (
            <div className="display_block">
                    <div className="order_row">
                        <div onClick={this.toogleTypes} className="input_container_border country_picker countries_picker_container">
                                <p className="country_picker_title">{strings.pickCountry}</p>
                                <div className="just_content">
                                    <div className="flex">
                                        <img className="country_icon" src={flag}/>
                                        <p className="country_picker_text">{this.state.filterPicked}</p>
                                    </div>
                                    
                                    <img style={this.state.isShowTypes ? arrowRotate : {}} className="choose_drop_arrow" src={arrow_filter}/>
                                </div>
                                {this.state.isShowTypes && <CountriesDropDown filters={this.state.countries} onFilterPicked={this.onTypePicked}/>}
                        </div>
                        <div className="input_description_container">
                            <p className="input_description_text">{strings.pickCountryDescription}</p>
                        </div>
                    </div>
            </div>
           
        );
    }
}
export default CountryPicker;